<template>
  <v-snackbar
    :color="alert.backgroundColor"
    v-model="alert.snackbar"
    :right="alert.position.right"
    :center="alert.position.center"
    :top="alert.position.top"
    multi-line
    :timeout="alert.timeout"
    style="z-index: 999999999"
  >
    <div class="d-flex">
      <div>
        <v-icon :color="alert.color + ' darken-1'">{{ alert.icon }}</v-icon>
      </div>
      <div class="pl-2">
        <span
          :style="`color: var(--v-${alert.color}-darken1)`"
          class="snackTitle"
        >
          {{ alert.title }}
        </span>
        <br />
        <span
          :style="`color: var(--v-${alert.color}-darken1)`"
          class="snackMessage"
        >
          {{ alert.message }}
        </span>
      </div>
    </div>

    <template v-slot:action="{ attrs }">
      <v-btn
        v-show="alert.actions.accept"
        text
        v-bind="attrs"
        @click="alert.accept()"
      >
        Sim
      </v-btn>
      <v-btn
        v-show="alert.actions.cancel"
        style="border-radius: 8px; text-transform: none"
        outlined
        :color="alert.color"
        v-bind="attrs"
        @click="alert.snackbar = false"
      >
        <span>Fechar</span>
      </v-btn>
    </template>
    <v-spacer></v-spacer>
  </v-snackbar>
</template>

<script>
export default {
  name: "snackbar-vue",
  data: () => ({
    alert: window.snackbarController,
  }),
};
</script>

<style scoped>
.snackTitle {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
.snackMessage {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
</style>